<template>
  <div class="flex flex-col bg-[#f8fafc] gap-4">
    <div class="bg-white rounded-xl shadow-sm border border-slate-200 border-t-4 border-t-[#0d4169] flex flex-col pt-3">
      <div class="relative z-30 px-6 pb-3 flex flex-col gap-4 border-b border-slate-100 bg-white">
        <div class="flex items-baseline gap-2 flex-wrap">
          <h2 class="text-base font-bold text-[#0d4169] text-left m-0">
            {{ resolvedCompanyName }}
          </h2>
          <span class="text-sm font-bold text-slate-600">Income Tax and Pension</span>
        </div>
      </div>

      <div class="relative z-0 px-6 py-4 flex flex-col gap-4">
        <PensionPage
          api-base="/hr"
          privilege-name="HR Pension And TAX"
          :hide-header="true"
        />
        <IncomeTax
          api-base="/hr"
          privilege-name="HR Pension And TAX"
          :hide-header="true"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'
import PensionPage from '../../finance/advancedRegister/pensionPage.vue'
import IncomeTax from '../../finance/advancedRegister/incomeTax.vue'

const store = useStore()

const currentUser = computed(() => store.getters.currentUser || store.state.user || {})

const resolvedCompanyName = computed(() => {
  const user = currentUser.value
  return (
    user?.company?.name ||
    user?.companyName ||
    user?.company_name ||
    user?.company?.company_name ||
    'Company Name'
  )
})
</script>
